module.exports = __webpack_public_path__ + "assets/images/54b88637bfb8d78658cf9906c0332480.png";